import React, { useEffect, useState } from "react";
import moment from "moment";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { debounce, get } from "lodash";
import {
  BlockHead,
  BlockTitle,
  BlockHeadContent,
  Icon,
  BlockBetween,
  RSelect,
  Block,
  Row,
  Col,
} from "../../components/Component";
import DataCard from "../../components/partials/default/DataCard";
import {
  DropdownItem,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  Badge,
} from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import UpdateUserModal from "./modals/UpdateUserModal";
import DeleteConfirmationModal from "../admin/modals/DeleteConfimationModal";
import { defaultParams, membershipTypes } from "../../constants";
import { resolveCountryName } from "../../constants/Country";
import { useDispatch } from "react-redux";
import {
  deleteUserSuccess,
  getListUser,
  updateUserSuccess,
} from "../../slice/users";
import { approveUser, deleteUser } from "../../api/user";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getDetailSuccess } from "../../slice/user-detail";

function getDefaultColumns(
  onEditClick,
  onDeleteClick,
  onApproveClick,
  isApproveLoading,
) {
  return [
    {
      head: <span className="sub-text">{"Avatar"}</span>,
      cell: (row) => (
        <img
          src={get(
            row,
            "avatar",
            "https://static.vecteezy.com/system/resources/previews/009/292/244/non_2x/default-avatar-icon-of-social-media-user-vector.jpg",
          )}
          style={{ width: 40, height: 40, borderRadius: 20 }}
        />
      ),
    },
    {
      head: <span className="sub-text">{"User"}</span>,
      cell: (row) => (
        <>
          <div
            style={{
              fontWeight: 600,
              marginBlock: 3,
              fontSize: 16,
            }}
          >
            {row.displayName || row.fullName || row.businessName || "-"}
          </div>
          <div>{get(row, "email", "")}</div>
        </>
      ),
    },
    {
      head: <span className="sub-text">{"Based In"}</span>,
      cell: (row) => <span>{resolveCountryName(row.basedIn)}</span>,
    },
    {
      head: <span className="sub-text">{"Role"}</span>,
      cell: (row) => (
        <>
          <span>{membershipTypes.find((t) => t.value === row.role)?.label ?? row.role}</span>
          {row.role === "service_provider" && (
            <>
              <br />
              <span>{row.serviceType}</span>
            </>
          )}
        </>
      ),
    },
    {
      head: <span className="sub-text">{"Status"}</span>,
      cell: (row) => (
        <span>
          <Badge
            className="badge-sm badge-dot has-bg d-none d-sm-inline-flex"
            color={row.approved ? "success" : "danger"}
          >
            {row.approved ? "Approved" : "Unapproved"}
          </Badge>
        </span>
      ),
    },
    {
      head: <span className="sub-text">{"Created At"}</span>,
      cell: (row) => (
        <span>
          {row.createdAt
            ? moment(row.createdAt).format("DD/MM/yyyy hh:mm:ss")
            : "-"}
        </span>
      ),
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <ul
          className="nk-tb-actions gx-1"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="dropdown-toggle btn btn-icon btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu end>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onApproveClick(row);
                      }}
                    >
                      <Icon
                        name={row.approved ? "user-cross" : "user-check"}
                      ></Icon>
                      <span>{row.approved ? "Unapprove" : "Approve"}</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#approved"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(row);
                      }}
                    >
                      <Icon name="eye"></Icon>
                      <span>{"Edit"}</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#delete"
                      className="link link-danger"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onDeleteClick(row);
                      }}
                    >
                      <Icon name="delete"></Icon>
                      <span>{"Delete"}</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];
}
const UsersPage = () => {
  const { list, summary, roleStats, loading } = useSelector(
    (state) => state.users,
  );
  const [isApproveLoading, setApproveLoading] = useState("-1");
  const [smOption, setSmOption] = useState(false);
  const navigate = useNavigate();
  const [params, setParams] = useState(defaultParams);
  const dispatch = useDispatch();
  const [isUserModalVisible, setUserModalVisible] = useState({
    user: null,
    update: false,
    delete: false,
  });
  const onEdit = (user) => {
    dispatch(getDetailSuccess(user));
    navigate(`/users/${user?._id}`);
  };
  const closeModal = () => {
    setUserModalVisible({
      user: null,
      delete: false,
      update: false,
    });
  };
  const onDelete = (user) => {
    setUserModalVisible({ user, delete: true });
  };

  useEffect(() => {
    dispatch(getListUser(params));
  }, [dispatch, params]);
  const handlePageChange = (page) => {
    setParams({
      ...params,
      page,
    });
  };
  /// func
  const onDeleteUser = async () => {
    try {
      await deleteUser(isUserModalVisible.user?._id);
      dispatch(deleteUserSuccess(isUserModalVisible.user));
      toast.success("Delete user successfully");
    } catch (error) {
      toast.error(error);
    }
  };
  const approvedCoach = async (user) => {
    setApproveLoading(user?._id);
    try {
      const res = await approveUser(user?._id, {
        approved: !user?.approved,
      });
      toast.success("Update user successfully");
      dispatch(updateUserSuccess(res));
    } catch (error) {
      toast.error(error);
    }
    setApproveLoading("-1");
  };
  const dataTableColumns = getDefaultColumns(
    onEdit,
    onDelete,
    approvedCoach,
    isApproveLoading,
  );

  const _handleInputChange = (value) => {
    setParams((prev) => ({
      ...prev,
      keyword: value,
    }));
  };
  const handleInputChange = debounce(_handleInputChange, 500);

  return (
    <React.Fragment>
      <Head title="Users"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Users</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="filter-unapproved"
                          checked={params.unapproved ?? false}
                          onChange={(e) => {
                            setParams({
                              ...params,
                              page: 1,
                              unapproved: e.target.checked,
                            });
                          }}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="filter-unapproved"
                        >
                          Unapproved
                        </label>
                      </div>
                    </li>
                    <li className="w-250px">
                      <div className="w-100">
                        <RSelect
                          options={membershipTypes}
                          isMulti
                          onChange={(val) => {
                            setParams({
                              ...params,
                              page: 1,
                              roles: val.map((e) => e.value),
                            });
                          }}
                          placeholder="Any Role"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{
                          height: "38px",
                        }}
                      >
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control h-100"
                          id="default-04"
                          placeholder="Search by name"
                          onChange={(e) => handleInputChange(e.target.value)}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {roleStats && (
          <Block>
            <Row className="g-gs">
              {membershipTypes.map((type) => {
                const stat = roleStats[type.value] ?? {
                  total: 0,
                  approved: 0,
                  unapproved: 0,
                };
                return (
                  <Col xxl="2" lg="3" md="4" sm="6" key={type.value}>
                    <DataCard
                      title={type.label}
                      amount={stat.total}
                      info={
                        <>
                          <span className="text-success me-2">
                            {stat.approved} <Icon name="check"></Icon>
                          </span>
                          <span className="text-danger">
                            {stat.unapproved} <Icon name="cross"></Icon>
                          </span>
                        </>
                      }
                    />
                  </Col>
                );
              })}
            </Row>
          </Block>
        )}
        <BasePaginationTable
          list={list}
          loading={loading}
          columns={dataTableColumns}
          onPageChange={handlePageChange}
          onRowClick={onEdit}
          hasNextPage={summary?.hasNextPage}
          totalItems={summary?.count}
          {...params}
        />
      </Content>
      <UpdateUserModal
        user={isUserModalVisible.user}
        isOpen={isUserModalVisible.update}
        closeModal={closeModal}
      />
      <DeleteConfirmationModal
        onConfirm={onDeleteUser}
        isOpen={isUserModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default UsersPage;
